import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { UserConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { EmployeeManagerService } from './api/employeeManager.service';
import { UserService } from './api/user.service';
import { UserAdminService } from './api/userAdmin.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class UserApiModule {
    public static forRoot(configurationFactory: () => UserConfiguration): ModuleWithProviders<UserApiModule> {
        return {
            ngModule: UserApiModule,
            providers: [ { provide: UserConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: UserApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('UserApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
